/**
 * @generated SignedSource<<9da86ec30c2a32829d78f7ede4cd3887>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentSuggestedPromptListItemQuestion$data = {
  readonly id: string;
  readonly text: string;
  readonly viewerBrainSearch: {
    readonly id: string;
  } | null;
  readonly viewerBrainSearchMessage: {
    readonly brainSearchId: string;
    readonly id: string;
  } | null;
  readonly " $fragmentType": "ContentSuggestedPromptListItemQuestion";
};
export type ContentSuggestedPromptListItemQuestion$key = {
  readonly " $data"?: ContentSuggestedPromptListItemQuestion$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentSuggestedPromptListItemQuestion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentSuggestedPromptListItemQuestion",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrainSearch",
      "kind": "LinkedField",
      "name": "viewerBrainSearch",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrainSearchMessage",
      "kind": "LinkedField",
      "name": "viewerBrainSearchMessage",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "brainSearchId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrainSearchRelatedQuestion",
  "abstractKey": null
};
})();

(node as any).hash = "0b7218a9cf1b2307ae111dbd695cf2e2";

export default node;
